import React from 'react'
import { useSelector } from 'react-redux'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function Payments({ classes }) {
	const shop = useSelector(state => state.shop)

	return (<div className={`${classes.page} ${classes.textPage}`}>
		<h2>{shop.shop_name}</h2>
		<h3>Metodi di pagamento</h3>
		<div dangerouslySetInnerHTML={{
			__html: shop.informations.payment_methods
		}}></div>
	</div>)
}

export default withStyles(style)(Payments)
